import React, {useState} from "react";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import ContextMenu from "../ContextMenu/ContextMenu";

const MenuButton = props => {
  const [isMenuOpen, setMenuOpen] = useState(false)
  const [menuX, setMenuX] = useState(0);
  const [menuY, setMenuY] = useState(0);

  const openMenu = (e) => {
    setMenuX(e.clientX);
    setMenuY(e.clientY);
    setMenuOpen(true);
  }

  return (
    <>
      <div className="menu-button" onClick={openMenu}>
        <MoreHorizIcon style={{width:32,height:32}}/>
      </div>
      {isMenuOpen &&
        <ContextMenu top={menuY} left={menuX} items={props.items} onClose={() => setMenuOpen(false)}/>
      }
    </>
  );
}

export default MenuButton;